import { render, staticRenderFns } from "./PadraoForm.vue?vue&type=template&id=5a24d992&scoped=true&"
import script from "./PadraoForm.vue?vue&type=script&lang=js&"
export * from "./PadraoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24d992",
  null
  
)

export default component.exports